
/* System defined core library */
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { SelectedExamDetailService } from '../../services/selected-exam-detail.service';
import { Exam } from '../../../../shared/models/scheduling/exam.model';
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { UtilityService } from '../../../../shared/services/utility.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-total-duration',
  templateUrl: './total-duration.component.html',
  styleUrls: ['./total-duration.component.scss']
})
export class TotalDurationComponent {

  /* User defined private/public variables  */
  public selectedAppointments: AppointmentDetail[] = [];
  public selectedAppointments$: Subscription;
  public totalDurationStr: string;
  public targetFlow: string;


  translateLanguage$: Subscription;

  /* Input-OutPut parameters decalartions */
  @Input() totalDuration: number;

  /* Constructor declaration with required injected services */
  constructor(private utilityService: UtilityService,
    private translate: TranslateService,
    private selectedExamDetailService: SelectedExamDetailService) {

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    );
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {

  }

  durationToStr(val: number) {
    return this.utilityService.durationToStr(val);
  }

}
